fx.ns("shared.popups", class LoadImportedFilesError extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text: fx.text("Je n'ai pas pu charger les pages de votre fichier"), className:"title center"}));
        this.addChild(new fx.components.Text({text: fx.text("J'ai rencontré un problème en essayant de charger les pages de votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

    onClose()
    {
        super.onClose();

        this.data.event("show-editor");
        this.data.event("save-creation");
    }
});